import React from 'react';

import { ListItem, List, Typography} from '@mui/material';
import { Box, CardActions, CardContent, CardMedia, Button, Link } from '@mui/material';
import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import { useTranslation } from 'react-i18next';
import { formatDate } from "/@/app/utils.jsx";
import { PaidPlanActions } from "./PaidPlanActions.jsx";


const PriceDetails = ({ plan, prefix }) => {
    const { t } = useTranslation();
    return ( // stub
        <Typography
            variant="body1"
            component="div"
            sx={{
            color: t => t.palette.primary.main,
            textAlign: 'center',
            mb: 1,
            lineHeight: '1.2em',
        }}>
            <Box sx={{ mb: 0 }}>
	        {t(plan.status?.prolongable?'Продлить спонсорство':'Стать спонсором прямо сейчас')}
            </Box>
            <Typography component="span" sx={{ whiteSpace: "nowrap", fontSize: 'smaller', color: 'black' }}>
                на {prefix} {" "}
                {
                    t({
                            day: 'price_day',
                            month: 'price_month',
                            year: 'price_year',
                        }[plan.duration_unit],
                        {count: plan.status?.prolongable?plan.duration+1:plan.duration}
                    )
                }
            </Typography>
        </Typography>
    );
}

export const SponsorUltimate2025Card = ({ plan, sx }) => {
    return (
        <>
            <CardMedia
                component="img"
                height="140"
                image="/images/subscriptionPlanStub.jpg"
            />
            <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                    Спонсорский План
                </Typography>
                <Typography component="div" variant="body1" sx={{ color: 'text.secondary', lineHeight: '1.3em' }}>
                    <List>
                        <ListItem>Все функции</ListItem>
                        <ListItem>Приоритетный доступ к новым функциям, недоступным по подписке Премиум</ListItem>
                        <ListItem>
                            <Typography component="span">
                                Персональная консультация в Whatsapp{" "}
                                <Typography component="span" variant='body1' sx={{ whiteSpace: "nowrap" }}>+996 998 974 454</Typography>
                            </Typography>
                        </ListItem>
                        <ListItem>
                            <Typography component="span">
                                В Max{" "}
                                <Typography component="span" variant='body1' sx={{ whiteSpace: "nowrap" }}>+7 925 924 43 28</Typography>
                            </Typography>
                        </ListItem>
                        {/*<ListItem>Вас отобразят в списке спонсоров проекта (по желанию)</ListItem>*/}
                    </List>
                </Typography>
            </CardContent>
            <CardActions sx={{
                flex: 1,
                display: 'flex',
                flexFlow: 'column nowrap',
                alignItems: 'center',
                justifyContent: 'flex-end',
            }}>
                {plan.status?.till ?
                    <></>
                    :
                    <>
                        <Typography variant="body2" sx={{
                            color: t => t.palette.text.secondary,
                            textAlign: 'center',
                        }}>
                            Чтобы стать спонсором по индивидуальным условиям, {" "}
                            <Link target="_blank"
                                  href="https://nestarenie.ru/sponsor_2.html"
                                  sx={{ textAlign: "center" }}
                            >
                                свяжитесь с нами
                            </Link>
                        </Typography>
                    </>
                }
            </CardActions>
            <PaidPlanActions
                plan={plan}
                mode={"priceWithDonationBox"}
                PriceDetailsComponent={PriceDetails}
            />
        </>
    )
}
